import './perks-popular-posts.component.scss';

import { h } from 'preact';
import { useEffect } from 'preact/hooks';

import { Pageable } from '../../../common/page/pageable.model';
import { useTranslation } from '../../../i18n';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { ActionType } from '../../model/user-action.inteface';
import { selectPopularPosts } from '../../store/perks.selectors';
import { loadPopularPosts } from '../../store/perks.thunk';
import { PerksPostSummary } from '../perks-post-summary/perks-post-summary.component';

interface Props {
  actionType?: ActionType;
  includeCommentActions?: boolean;
  count?: number;
}

export const PerksPopularPosts = ({
  actionType = ActionType.LIKE,
  includeCommentActions = false,
  count = 5,
}: Props) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const popularPosts = useAppSelector(selectPopularPosts);

  useEffect(() => {
    dispatch(
      loadPopularPosts({
        request: {
          actionType: actionType ?? ActionType.LIKE,
          includeCommentActions: includeCommentActions ?? false,
        },
        pageable: Pageable.of(0, count ?? 5),
      })
    );
  }, [dispatch, actionType, includeCommentActions, count]);

  return (
    <>
      {popularPosts && popularPosts.length > 0 && (
        <div class="single-popular-posts-container">
          <h4 class="h4 single-h4">{t('perks.popularPosts')}</h4>
          {popularPosts.map((post) => (
            <PerksPostSummary key={post.id} post={post} />
          ))}
        </div>
      )}
    </>
  );
};
